module.exports = __webpack_public_path__ + "static/media/garage-premium.861510f3.webm";